export default __webpack_public_path__ + "static/media/icon-person-error-male-desktop.4414bb7c.svg";